import { useFlagsmith } from 'flagsmith/react';

export function useIsInternalUser() {
  const flagsmith = useFlagsmith();
  // Traits are returned as a string, so we check if it equals 'true'
  return flagsmith.getTrait('internaluser') === 'true';
}
